import { type ReactNode } from 'react';
import { Modal, Pressable } from 'react-native';

import { cn } from './cn';

export interface DialogProps {
  visible: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

/** Centered modal card (confirmations, small forms). */
export function Dialog({ visible, onClose, children, className }: DialogProps) {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <Pressable
        className="flex-1 items-center justify-center bg-black/40 px-6"
        onPress={onClose}
      >
        <Pressable
          className={cn(
            'w-full max-w-md rounded-3xl border border-border bg-background p-5',
            className,
          )}
          onPress={(e) => e.stopPropagation()}
        >
          {children}
        </Pressable>
      </Pressable>
    </Modal>
  );
}
